import { render, staticRenderFns } from "./GridTailwind.vue?vue&type=template&id=55a88bae&"
import script from "./GridTailwind.vue?vue&type=script&lang=js&"
export * from "./GridTailwind.vue?vue&type=script&lang=js&"
import style0 from "./GridTailwind.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports